import * as Yup from "yup";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createTextWithPagesElementFormSchema = (t: TFunc) =>
	Yup.object({
		title: Yup.string().required(t("validation:titleFieldRequired")),
	});
